import { Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { OUTAGE_BANNER_HEIGHT } from '~/pages/_app';
import { env } from '~/env.mjs';

export function OutageBanner() {
  return (
    <div
      className="fixed left-0 right-0 top-0 z-[200] flex w-full items-center justify-center gap-2 border-b border-yellow-400 bg-yellow-300 py-2"
      style={{ height: `${OUTAGE_BANNER_HEIGHT}px` }}
    >
      <IconAlertCircle
        size={16}
        className="text-yellow-900"
      />
      <Text
        className="text-yellow-900"
        size="sm"
      >
        {env.NEXT_PUBLIC_OUTAGE_BANNER_MESSAGE ||
          'We are currently experiencing service disruptions due to outages with Anthropic and Google Cloud. This may impact the availability of some features.'}
      </Text>
    </div>
  );
}
